export function drawOpacity(renderContext, node, render) {
  const { context } = renderContext;
  // 仅当 opacity 存在且不为 1 时才处理
  if (typeof node.opacity === 'number' && node.opacity >= 0 && node.opacity < 1) {
    context.globalAlpha = node.opacity;
    render();
    context.globalAlpha = 1;
  } else {
    render();
  }
}
